'use client'
import React from "react";
import Head from "next/head";
import Script from "next/script";

/**
 * @param {HeaderProps}
 */

const FAQPage = ({ elem, id }) => {
  /* const schema = {
    "@context": "http://schema.org",
    "@type": "FAQPage",
    mainEntity:
      faqpage &&
      faqpage.length > 0 &&
      faqpage.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: faq.answer,
        },
      })),
  }; */

  if (elem.datas) {
    return (
      <Script
        id={`meta-element-${id}`}
        type="application/ld+json"
        strategy="afterInteractive" // Ensures it loads correctly after hydration
        dangerouslySetInnerHTML={{ __html: JSON.stringify(JSON.parse(elem.datas)) }}
      />
    );
  }
  return
};

const CHead = ({ page }) => {
  console.log(page.data.meta_page);
  return (
    <React.Fragment>
      {/* <Script type="text/javascript" src="https://cdn.logr-ingest.com/LogRocket.min.js" crossorigin="anonymous"></Script>
            <Script async type="text/javascript" src="/js/logrocket.js"></Script> */}
      <Head>
        <meta name="title" content={page.data.seo_title} />
        <meta name="description" content={page.data.seo_description} />
        <meta property="og:title" content={page.data.og_title} />
        <meta property="og:description" content={page.data.og_description} />
        <link rel="canonical" href={page.data.canonic_url} />
        <meta property="og:image" content={page.data.meta_image.url} />
        <title>{page.data.title}</title>
        <noscript>
          <img height="1" width="1" style={{ display: "none" }}
            src="https://www.facebook.com/tr?id=879637007594017&ev=PageView&noscript=1"
          /></noscript>
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MJ5GL367"
          height="0" width="0" style={{ display: "none", visibility: "hidden" }}></iframe></noscript>
      </Head>
      {
        page.data.meta_page.map((elem, i) => <FAQPage elem={elem} key={i} id={i} />)
      }
      <link rel="preload" href="/images/grain-texture.webp" as="image" fetchPriority="high" />
      <link rel="icon" href="/favicon.ico" sizes="any" type="image/svg+xml" />
      <Script async type="text/javascript" src="/js/gtag.js"></Script>
      <Script defer type="text/javascript" id="hs-script-loader" src="//js.hs-scripts.com/20272221.js" async></Script>
      <Script async type="text/javascript" src="/js/ndrstnd.js"></Script>
      <Script type="text/javascript" charset="utf-8" src="//js.hsforms.net/forms/embed/v2.js"></Script>
      <Script async defer type="text/javascript" src="https://static.cdn.prismic.io/prismic.js?new=true&repo=berkail-v2"></Script>

      {/* <Script async type="text/javascript" src="/js/matomo.js"></Script> */}

    </React.Fragment>
  )
}



export default CHead;
